import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  Stack,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { ThaiStar, ThaiQuatrefoil, ThaiDivider } from './ThaiMotif';

interface EducationItem {
  degree: string;
  school: string;
  location: string;
  period: string;
  flag: string;
}

const educationItems: EducationItem[] = [
  {
    degree: 'Master of Data Science',
    school: 'University of Sydney',
    location: 'Sydney, Australia',
    period: '2019 - 2021',
    flag: '🇦🇺',
  },
  {
    degree: 'Bachelor of Electrical Engineering',
    school: 'University of New South Wales',
    location: 'Sydney, Australia',
    period: '2017 - 2019',
    flag: '🇦🇺',
  },
  {
    degree: 'Bachelor of Electrical Engineering',
    school: 'Thammasat University',
    location: 'Bangkok, Thailand',
    period: '2015 - 2017',
    flag: '🇹🇭',
  },
];

const Education: React.FC = () => {
  return (
    <Box
      id="education"
      sx={{
        py: { xs: 10, md: 14 },
        background: '#FAF6EE',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Thai motif decorations */}
      <ThaiStar size={120} opacity={0.04} rotate={10} sx={{ top: '8%', right: '4%' }} />
      <ThaiQuatrefoil size={70} opacity={0.035} strokeOnly sx={{ bottom: '12%', left: '4%' }} />
      <ThaiStar size={45} opacity={0.03} rotate={-20} sx={{ bottom: '30%', right: '2%' }} />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="overline"
            sx={{
              color: '#C8A24D',
              fontWeight: 600,
              letterSpacing: 3,
              fontSize: '0.8rem',
              mb: 1.5,
              display: 'block',
            }}
          >
            EDUCATION
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontSize: { xs: '1.8rem', md: '2.5rem' }, color: '#2A231C' }}
          >
            Academic{' '}
            <Box component="span" className="serif-heading" sx={{ color: '#C8A24D' }}>
              Background
            </Box>
          </Typography>
          <ThaiDivider />
        </Box>

        <Stack spacing={3}>
          {educationItems.map((edu, index) => (
            <Card
              key={index}
              className="card"
              sx={{
                p: { xs: 3, md: 4 },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: 2, md: 3 },
                  alignItems: { xs: 'flex-start', md: 'center' },
                  flexDirection: { xs: 'column', md: 'row' },
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: '12px',
                    background: 'rgba(200, 162, 77, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.8rem',
                    flexShrink: 0,
                  }}
                >
                  {edu.flag}
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: { xs: '1.05rem', md: '1.15rem' },
                      mb: 0.5,
                      color: '#2A231C',
                    }}
                  >
                    {edu.degree}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#C8A24D',
                      fontWeight: 500,
                      fontSize: '0.9rem',
                      mb: 1,
                    }}
                  >
                    {edu.school}
                  </Typography>
                  <Stack direction="row" spacing={2} flexWrap="wrap">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <LocationOnIcon sx={{ fontSize: 15, color: '#9CA3AF' }} />
                      <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '0.85rem' }}>
                        {edu.location}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <CalendarTodayIcon sx={{ fontSize: 14, color: '#9CA3AF' }} />
                      <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '0.85rem' }}>
                        {edu.period}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </Card>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

export default Education;
